import { render, staticRenderFns } from "./DialogChangeWorkflow.vue?vue&type=template&id=01148c60&scoped=true"
import script from "./DialogChangeWorkflow.vue?vue&type=script&lang=js"
export * from "./DialogChangeWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01148c60",
  null
  
)

export default component.exports